class SMARTiFrameMessenger {
    constructor(iframeRef = null, debug = false) {
        this.isIframe = iframeRef === null;
        this.iframeRef = iframeRef;
        this.debugMode = debug;
        this.messageHandlers = [];
        // Remove any existing event listener before adding a new one
        if (window.__SMARTiFrameMessengerHandler) {
            window.removeEventListener('message', window.__SMARTiFrameMessengerHandler);
        }
        // Bind and store the handler so we can remove it later
        this.messageHandler = (event) => this.handleMessage(event);
        window.__SMARTiFrameMessengerHandler = this.messageHandler;
        // Add message listener
        window.addEventListener('message', this.messageHandler, false);
    }
    sendMessage(message) {
        if (this.isIframe) {
            // Send message to parent
            this.debugLog('iFrame Send Message:', message);
            window.parent.postMessage(message, '*');
        }
        else if (this.iframeRef && this.iframeRef.contentWindow) {
            // Send message to iframe
            this.debugLog('Parent Send Message:', message);
            this.iframeRef.contentWindow.postMessage(message, '*');
        }
        else {
            console.warn('Warning: iframe reference is missing or invalid.');
        }
    }
    handleMessage(event) {
        let handlerFound = false;
        this.debugLog((this.isIframe ? 'iFrame' : 'Parent') + ' Received Message:', event.data, 'from origin', event.origin);
        if (this.messageHandlers.length) {
            // Call handlers that match the origin or have no origin restriction
            this.messageHandlers.forEach(({ handler, origin }) => {
                if (!origin || origin === event.origin) {
                    handlerFound = true;
                    handler(event.data);
                }
            });
            if (!handlerFound) {
                console.warn((this.isIframe ? 'iFrame' : 'Parent') + ' Warning: No handler found for this origin');
            }
        }
        else {
            console.warn((this.isIframe ? 'iFrame' : 'Parent') + ' Warning: No handlers have been registered');
        }
    }
    onMessage(handler, origin = null) {
        // Add a message handler function with optional origin filtering
        if (typeof handler === 'function') {
            this.messageHandlers.push({ handler, origin });
        }
    }
    debugLog(...args) {
        if (this.debugMode) {
            console.log(...args);
        }
    }
    destroy() {
        window.removeEventListener('message', this.messageHandler);
        this.messageHandlers = [];
    }
}
export default SMARTiFrameMessenger;
//# sourceMappingURL=SMARTiFrameMessenger.js.map